import i18n from "i18next";

export function getLanguage() {
    const pathname = window.location.pathname;
    return pathname.substring(1, 3);
}

export function setLanguage(lang) {
    i18n.changeLanguage(lang);
}